module.exports = __webpack_public_path__ + "img/946.1711395a.gif";